import api from "../core/axios";

export const legislationApi = {
    //Resolution & Ordinance Tab API
    dashboard: () => api.get("/legislations/dashboard"),
    get: (params) => api.get("/legislations", { params }),
    create: (data) => api.post("/legislations", data),
    update: ({ id, payload }) => api.post(`/legislations/${id}`, payload),
    archive: (data) => api.post(`/legislations/${data.id}/archive`, data ),
    getLegislation: (id, params) => api.get(`/legislations/${id}`, { params }),
    getSponsorsSelect: () => api.get("/legislations/select-sponsors"),
    getCommitteesSelect: () => api.get("/legislations/select-committees"),
    getChairmanshipSelect: () => api.get("/legislations/committees/select-chairmanships"),

    //Legislative Document Tab API
    getTabView: (params) => api.get("/legislations/tab-view", { params }),
    getVersionId: (id) => api.get(`/legislations/document-versions/${id}`),
    uploadVersion: (id, payload) => api.post(`/legislations/${id}/document-versions/upload-new`, payload),
    updateVersion: (legislativeId, versionId, data) =>  api.post( `/legislations/${legislativeId}/document-versions/${versionId}/update`, data),

    //History & Archives Tab API
    restoreArchivedLegislation: (id) => api.patch(`/legislations/${id}/restore-archived`),

    //Public Consultation API
    updateConsultationRecord: (id, data) => api.post(`/legislations/consultation-records/${id}`, data),
    getConsultationRecord: (id) => api.get(`/legislations/consultation-records/${id}`),
    uploadConsultationRecord: (id, data) => api.post(`/legislations/${id}/consultation-records/upload-new`, data),

    //Commitee API
    getCommittees: (params) => api.get("/legislations/committees", { params }),
    createCommittee: (data) => api.post("/legislations/committees", data),
    updateCommittee: (id, data) => api.patch(`/legislations/committees/${id}`, data),

}
